import React, { Component } from 'react'
import { Button } from 'components/elements'
import { withRouter } from 'react-router-dom'
import { addToUrlPush, removeFromUrlPush } from '../filterUtil.js'
import { PAGE_FILTER_SHORT_NAME } from '../pagination/paginationFilterConfig.js'

export const INSTANT_BOOKING_SHORT_NAME = 'instantBooking'
export const bookingFilterDefault = false

export const INSTANT_BOOKING_FILTER_CONFIG = {
  short_name: INSTANT_BOOKING_SHORT_NAME,
  default_values: bookingFilterDefault,
  is_default: (value) => false,
  format_to_api: (value) => formatInstantBookingForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: (value) => formatInstantBookingFromURL(value), //
}

//api

export const formatInstantBookingForAPI = (value) => {
  if (value) {
    return { instant_booking: value }
  }
}

export const formatInstantBookingFromURL = (value) => {
  return value
}

class InstantBookingConfig extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentConfig: this.props.currentConfig.instantBooking ? true : false,
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentConfig.instantBooking !==
      this.props.currentConfig.instantBooking
    ) {
      this.setState({
        currentConfig: this.props.currentConfig.instantBooking,
      })
    }
  }

  handleApply = () => {
    let tempLocationSearch = this.props.location.search
    if (this.props.location.search?.includes('&page=')) {
      const { string } = removeFromUrlPush(
        [PAGE_FILTER_SHORT_NAME],
        tempLocationSearch
      )
      tempLocationSearch = string
    }
    if (this.state.currentConfig === false) {
      let valuesToAdd = [{ key: INSTANT_BOOKING_SHORT_NAME, value: true }]

      let newQueryString = addToUrlPush(valuesToAdd, tempLocationSearch)
      this.props.history.push('?' + newQueryString.string)
    } else {
      let newQueryString = removeFromUrlPush(
        [INSTANT_BOOKING_SHORT_NAME],
        tempLocationSearch
      )
      this.props.history.push('?' + newQueryString.string)
    }
    if (this.state.currentConfig === true) {
      this.setState({ currentConfig: false })
      this.props.onApply(false)
    } else {
      this.setState({ currentConfig: true })
      this.props.onApply(true)
    }
  }
  render() {
    console.log('prop', this.props);
    return (
      <Button
        className={
          this.props.currentConfig.instantBooking
            ? 'is-primary'
            : 'filterBtnClass filters-bar-buttons'
        }
        onClick={() => this.handleApply()}
      >
        <i className="fas fa-bolt bolt-custom-icon"></i>
        Book Instantly
      </Button>
    )
  }
}

export default withRouter(InstantBookingConfig)
